import { render, staticRenderFns } from "./home-news-and-lms.vue?vue&type=template&id=5366f6b8&scoped=true"
import script from "./home-news-and-lms.vue?vue&type=script&lang=js"
export * from "./home-news-and-lms.vue?vue&type=script&lang=js"
import style0 from "./home-news-and-lms.vue?vue&type=style&index=0&id=5366f6b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5366f6b8",
  null
  
)

export default component.exports